import React from 'react'
import { Section, ISection } from './Section'

interface SectionBodyProps {
    className?: string
    section: ISection
}

export const SectionBody: React.FC<SectionBodyProps> = ({
    className,
    section,
}) => (
    <div className={className} data-testid="section-body">
        <div className="mx-auto w-full max-w-[1024px] px-6 py-12">
            <Section {...section} />
        </div>
    </div>
)
